module.exports = __webpack_public_path__ + "img/filter.414e955b.svg";